module.exports = __webpack_public_path__ + "img/xunlian.0274dc6f.svg";